function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextInput from '../TextInput/TextInput';
import PredictionList from '../PredictionList/PredictionList';
import emitter from '../../utils/emitter';
import './styles'; // for IE compatibility…

export var find = function find(haystack, predicate) {
  var needle = haystack.filter(predicate);

  if (needle.length === 0) {
    return null;
  }

  return needle[0];
};

var TypeAhead = /*#__PURE__*/function (_Component) {
  _inheritsLoose(TypeAhead, _Component);

  TypeAhead.getDerivedStateFromProps = function getDerivedStateFromProps(props) {
    // manually incrementing index because after transpiling map wasn't passing `index`
    var index = 0;
    var predictions = (props.predictions || []).map(function (p) {
      return _extends({}, p, {
        __id__: "" + index++ + p.text
      });
    });
    return {
      menuOpen: predictions.length > 0,
      predictions: predictions
    };
  };

  function TypeAhead(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.identifySelection = _this.identifySelection.bind(_assertThisInitialized(_this));
    _this.onSelection = _this.onSelection.bind(_assertThisInitialized(_this));
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_this));
    _this.onEscapeKey = _this.onEscapeKey.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.eventSubscriptions = [];

    _this.eventSubscriptions.push(emitter.addListener('identifySelection', _this.identifySelection(emitter)));

    _this.eventSubscriptions.push(emitter.addListener('onSelection', _this.onSelection));

    _this.eventSubscriptions.push(emitter.addListener('escapeKey', _this.onEscapeKey));

    _this.mounted = false;
    _this.typeahead = /*#__PURE__*/React.createRef();
    _this.state = {
      predictions: []
    };
    return _this;
  }

  var _proto = TypeAhead.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    document.addEventListener('mousedown', this.handleClick, false);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
    this.eventSubscriptions.map(this.unsubscribe);

    if (typeof document === 'object') {
      // Make sure we are SSR safe.
      document.removeEventListener('mousedown', this.handleClick, false);
    }
  };

  _proto.unsubscribe = function unsubscribe(subscription) {
    subscription.remove();
  };

  _proto.handleClick = function handleClick(e) {
    if (this.typeahead.current.contains(e.target)) {
      return;
    }

    this.setState({
      hideMenu: true
    });
  };

  _proto.onChange = function onChange(text) {
    if (this.mounted) {
      this.setState({
        hideMenu: false,
        text: text
      });
    }

    this.props.onChange(text);
  };

  _proto.onFocus = function onFocus(e) {
    this.props.onFocus(e);
  };

  _proto.identifySelection = function identifySelection(emitterImpl) {
    var _this2 = this;

    return function (id) {
      var match = find(_this2.state.predictions, function (p) {
        return p.__id__ === id;
      });
      emitterImpl.emit('onSelection', match);
      emitterImpl.emit('focus', null);
    };
  };

  _proto.onEscapeKey = function onEscapeKey() {
    this.props.onEscapeKey();
  };

  _proto.onSelection = function onSelection(value) {
    this.setState({
      hideMenu: true
    });
    this.props.onSelection(value);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        defaultValue = _this$props.defaultValue,
        label = _this$props.label,
        onEnterKey = _this$props.onEnterKey,
        useBolding = _this$props.useBolding,
        id = _this$props.id;
    var _this$state = this.state,
        hideMenu = _this$state.hideMenu,
        menuOpen = _this$state.menuOpen,
        predictions = _this$state.predictions,
        text = _this$state.text;
    var showMenu = menuOpen && !hideMenu;
    return /*#__PURE__*/React.createElement("div", {
      className: "typeahead",
      ref: this.typeahead
    }, /*#__PURE__*/React.createElement(TextInput, {
      defaultValue: defaultValue,
      label: label,
      menuOpen: showMenu,
      onChange: this.onChange,
      onEnterKey: onEnterKey,
      onFocus: this.onFocus,
      id: id
    }), /*#__PURE__*/React.createElement(PredictionList, {
      menuOpen: showMenu,
      predictions: predictions,
      input: text,
      useBolding: !!useBolding
    }));
  };

  return TypeAhead;
}(Component);

TypeAhead.propTypes = {
  /** The initial value for the input */
  defaultValue: PropTypes.string,

  /** The text for the text input's label*/
  label: PropTypes.string.isRequired,

  /** True of we should bold matching text. */
  useBolding: PropTypes.bool,

  /** Called with the user-provided input */
  onChange: PropTypes.func.isRequired,

  /** Called when the user presses the enter key */
  onEnterKey: PropTypes.func.isRequired,

  /** Called when the user presses the escape key */
  onEscapeKey: PropTypes.func.isRequired,

  /** Called with the selected text */
  onSelection: PropTypes.func.isRequired,

  /** The predicted text to be appended to typedText*/
  predictedText: PropTypes.string,

  /** The id for input field */
  id: PropTypes.string,

  /** Array of predictions to present to the user */
  predictions: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired
  }))
};
TypeAhead.defaultProps = {
  predictions: [],
  onFocus: function onFocus() {}
};
export default TypeAhead;
//# sourceMappingURL=TypeAhead.js.map